import React from 'react'

const surviving = {
    id: 'surviving-vietnam',
    type: 'post',
    countryId: 'seAsia',
    title: 'Surviving your First Few Days in Vietnam',
    longDate: 'Jan 2, 2019',
    month: 'Jan',
    date: '2',
    coverImage: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/surviving/train.JPG',
    coverImagePosition: 'bottom',
    content: [
        {
            text: (
                <div>Vietnam is an incredible place to visit. It has amazing food, culture, sites, and wonderful people. But, there are a few things we found difficult to adjust to when we got here. Here are a few tips which should make sure your first few days are full of wonder, not frustration.</div>
            )
        },
{
            header: 'Crossing the Street'
        },
{
            text: (
                <div>The traffic here is insane! The streets are clogged with motorbikes and cars, which are always inches from hitting each other. In the words of the late Mad-Eye Moody, you must always exercise CONSTANT VIGILANCE. Be aware and expect the unexpected.</div>
            )
        },
{
            text: (
                <div><ul>
<li>Right of way in Vietnam is determined by vehicle size. So, you as a pedestrian never have it.</li>
<li>Traffic lights are guidelines, not rules. Actually, don’t expect anyone to follow any traffic laws.</li>
<li>Motorbikes will use the sidewalk if the road is too busy (which it is all the time).</li>
<li>Drivers drive on the right side of the road unless it’s inconvenient, slow, difficult, or they just don’t feel like it. Expect traffic from all directions.</li>
</ul></div>
            )
        },
 {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/surviving/motorbikes.jpeg',
            detailText: 'Expect the streets to be packed with motorbikes.'
        },

{
            text: (
                <div>When attempting the fabled street crossing, you shouldn’t expect the traffic to wait for you. Instead, you should walk very slowly across the street and let the motorbikes drive around you. Don’t make any sudden movements – the bikes will anticipate your path and drive around you. However, cars have less maneuverability – do try to wait for a break in cars before crossing. You can optionally wave your hand at bikes so you’re more visible. The first few times, you should find some locals and walk across next to them to get a feel for it.</div>
            )
        },


{
            text: (
                <div>And finally, NEVER walk in front of a bus. They will not stop. <a href='https://www.youtube.com/watch?v=IkTw7J-hGmg'>Because buses don’t stop for anything.</a></div>
            )
        },
{
            header: 'Street Food'
        },
{
            text: (
                <div>You’ve probably heard a bunch of stories about how dangerous it is to eat street food in Southeast Asia and how likely you are to get sick. Personally, we’ve found all of this fearmongering to be very overblown. Sure, the food safety standards here aren’t quite as good as in the U.S., but we’ve eaten a lot of street food and have yet to get food poisoning from it. And it’s just so damn good.</div>
            )
        },
{
            text: (
                <div>That being said, there are a few things you should avoid in the first few days while your stomach adjusts to the new cuisine:
<ul><li>Avoid fresh ingredients at dicey looking places. If you’re in a building, you’re probably fine, but if you’re getting something from a cart, stick to cooked food.</li>
<li>If you’re getting meat, look for places where they are running the BBQ outside or the meat is coming from a pot of boiling water. A lot of restaurants will only cook their meat at certain times and serve cold leftovers the rest of the time. Not only is it rarely refrigerated, it doesn’t taste nearly as good.</li>
<li>Don’t overdo the fried food. Though frying food kills any bacteria, eating too much will also give you a stomachache.</li></ul></div>
            )
        },
 {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/surviving/streetFood.JPG',
            detailText: 'The street food here is awesome. Eat it all!'
        },
{
            header: 'Pepto'
        },
{
            text: (
                <div>Another thing you can do to avoid the minor stomachaches which are more common here is taking Pepto Bismol preventatively. A study showed that taking four Pepto Bismol tablets a day <a href='https://jamanetwork.com/journals/jama/article-abstract/364949'>reduced the risk of traveler's diarrhea by 60%!</a> For the first couple of weeks here, we took Pepto before each street food meal and didn’t have any stomach issues. Note that this has only been shown to work for the tablets, not the liquid.</div>
            )
        },
{
            header: 'Grab'
        },
{
            text: (
                <div><a href='https://www.grab.com/vn/en/'>Grab</a> is the Southeast Asian equivalent of Uber or Lyft. You should download the app and create an account before you arrive. That way, you can easily sign up with your U.S. number. Sadly, you can no longer add a foreign credit card as they only accept Vietnamese credit cards, but you can pay for all your rides in cash. Side note: the app doesn’t include airport fees or toll roads, so don’t be surprised if you’re charged extra for airport pick-ups at the end of your ride.</div>
            )
        },
{
            header: 'SIM Cards'
        },
{
            text: (
                <div>Data is really cheap here and you should definitely get a SIM card at the airport when you arrive. Viettel is the main government sponsored Internet provider. Apparently, Vietnam has been clamping down on other ‘less legitimate’ companies, but I think that anything you find at the airport should be fine. Don’t expect to pay much (~$5), and they will take a photocopy of your passport as a requirement for buying.</div>
            )
        },
{
            header: 'Water'
        },
{
            text: (
                <div>You can’t drink the tap water here, which means a lot of plastic water bottle use. We’ve been buying large 5 gallon bottles of water and putting them in the fridge. This saves money, saves plastic, and saves trips to the store. The locals here also don’t drink the tap water, so don’t worry if you’re served a glass of water in a restaurant or cafe – it won’t be tap water. They get their ice delivered which is also made with fresh, filtered water.</div>
            )
        },
{
            header: 'Tipping'
        },
{
            text: (
                <div>Tipping isn’t expected in Vietnam, which is awesome! You can round up bills or tip if you want, but you’ll always get back exact change otherwise.</div>
            )
        },
{
            header: 'Laughing'
        },
{
            text: (
                <div>Vietnamese people laugh a lot. Often, you won't really understand what they find so funny, but don’t worry too much about it – they’re probably not laughing at you. They also sometimes laugh when they are embarrassed. So, if you complain about something being wrong, they may start laughing. They’re not laughing at you... they’re just Vietnamese!</div>
            )
        },
{
            text: (
                <div>Here’s a recent conversation with someone from Southeast Asia (in this case, he was Thai):</div>
            )
        },
{
            text: (
                <div><i>Him: Where are you from, my friend?</i></div>
            )
        },
{
            text: (
                <div><i>Me: California.</i></div>
            )
        },
{
            text: (
                <div><i>Him: *Starts laughing uncontrollably for about 10 seconds and then offers no other comment*.</i></div>
            )
        },
{
            header: 'Getting Ripped Off'
        },
{
            text: (
                <div>In general, we’ve found people in Vietnam to be very honest. Sometimes, we haven’t fully understood a price and have handed over 50,000 dong only to have them shake their head and say, “No, no. Only five!” That being said, there are definitely some scams here and you are expected to barter for most consumer goods you buy on the street.</div>
            )
        },
{
            text: (
                <div>Our rule has been to decide on whether the seller commonly gets western customers. If we’re buying something from a local market and we get overcharged by 20 cents, we don’t think about it. We’re happy to support them. If we’re in a touristy area and someone’s trying to charge us 10x for a taxi, we’ll barter hard and often just walk away.</div>
            )
        },
{
            header: 'Getting Small Bills'
        },
{
            text: (
                <div>All the ATMs here give out 500,000 VND bills – approximately the equivalent of a US $20 bill. This is a lot of money for most transactions, and many places just won’t be able to give you change (especially street vendors and Grab drivers). Whenever you are at a place that looks like it carries change (ticket offices, restaurants, western cafes), always pay with a 500,000 to get small change. You should always try to keep some small bills on you so you don’t get stuck with a 30,000 dong bill and nothing small enough to pay for it with.</div>
            )
        },
 {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/surviving/streetFoodStall.jpeg',
        },

{
            header: 'Not Getting What You Order'
        },
{
            text: (
                <div>At many local restaurants, they won’t speak much (if any) English. Being such nice people, they will often just smile and nod as you ask questions and try to communicate your order. You usually get pretty close to what you want, but often, it won’t be quite right. All of these have happened to us:
<ul>
<li>If you order a cold beer, you may get a warm beer and a glass with ice.</li>
<li>If you order fresh spring rolls, you may get fried (response: “Yes, yes. Fresh spring rolls. Very fresh before fried.”)</li>
<li>If you order two spring rolls, you may get two plates of spring rolls and a waitress with wide eyes humored by how much Americans eat.</li>
<li>After carefully selecting all the dumplings you want and the waiter telling you some are out of stock, you get a random assortment which vaguely resembles some of your order.</li>
</ul>
</div>
            )
        },
{
            text: (
                <div>Our advice here is just to go with it. You may end up liking what you’re served more than what you actually wanted! Additionally, some places will give you the works without you asking. So, if you order rice and chicken, they’ll also bring you some spring rolls, a salad, or some tea. Usually, this ends up being an extra 25 cents, so just enjoy the VIP service.</div>
            )
        },
{
            header: 'Vietnam is Awesome'
        },
{
            text: (
                <div>You will have so many amazing experience in Vietnam. Some people are uncomfortable by how different it is and feel on edge or worried about being cheated. This is totally unnecessary and just leads to lots of awkward interactions. Just relax, embrace the crazy moments, and laugh like you’re Vietnamese.</div>
            )
        },
]
}

export default surviving


// WEBPACK FOOTER //
// ./src/Posts/Content/surviving.js